export default __webpack_public_path__ + "3cfe21687d062417a27c591d572418e3.svg";